import './polyfills.ts';

import 'zone.js/dist/zone';
import 'reflect-metadata';



// WEBPACK FOOTER //
// ./Client/polyfills/browser.polyfills.ts